import React from 'react'
import PatientRequestsList from '../patients/PatientRequestList'
import { MdUpdate } from 'react-icons/md'
import NurseAssignmentsList from './NurseAssignmentList'

function NurseRecords({ userObject }) {
    return (
        <div className='space-y-5'>
            <p className='font-bold text-lg'>{userObject?.user?.role} Requests</p>
            {userObject?.user?.role === 'Patient' && (
                <div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        <div className="relative overflow-hidden rounded-xl border border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark p-6 shadow-sm transition-all hover:shadow-md">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm font-medium text-slate-500 dark:text-slate-400">Total Requests</p>
                                    <p className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">{userObject?.request_count || 0}</p>
                                </div>
                                <div className="rounded-lg bg-primary/10 text-primary p-2 md:p-3 ">
                                    <span className="material-symbols-outlined"><MdUpdate className='h-6 w-6' /></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {userObject?.user?.role === 'Patient' && <PatientRequestsList patientId={userObject?.id} />}

            {userObject?.user?.role === 'Nurse' && (
                <div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        <div className="relative overflow-hidden rounded-xl border border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark p-6 shadow-sm transition-all hover:shadow-md">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm font-medium text-slate-500 dark:text-slate-400">Total Requests</p>
                                    <p className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">{userObject?.request_count || 0}</p>
                                </div>
                                <div className="rounded-lg bg-primary/10 text-primary p-2 md:p-3 ">
                                    <span className="material-symbols-outlined"><MdUpdate className='h-6 w-6' /></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {userObject?.user?.role === 'Nurse' && <NurseAssignmentsList nurseId={userObject?.id}/>}
        </div>
    )
}

export default NurseRecords